// extracted by mini-css-extract-plugin
export default {"container":"OduAP3DczymYyyV4r1hY"};